import type { SurveyImageSize } from './survey-question.types'

/** Figma 4399:8965 — small image well (187×140). */
const SMALL_WIDTH_PX = 187
const SMALL_HEIGHT_PX = 140

export type PictureChoiceDimensions = {
  width: number
  height: number
}

/** Builder tier baseline (small) used to scale medium/large proportionally. */
const BUILDER_TIER_SMALL = 72

/** Medium/large grow width and height by the same builder tier delta (+32 / +64 px). */
function scaleDimensions(tierPx: number): PictureChoiceDimensions {
  const delta = tierPx - BUILDER_TIER_SMALL
  return {
    width: SMALL_WIDTH_PX + delta,
    height: SMALL_HEIGHT_PX + delta,
  }
}

/** SP picture-choice image well — small from Figma; medium/large scale width and height. */
export function pictureChoiceDimensions(size: SurveyImageSize): PictureChoiceDimensions {
  switch (size) {
    case 'small':
      return { width: SMALL_WIDTH_PX, height: SMALL_HEIGHT_PX }
    case 'large':
      return scaleDimensions(136)
    default:
      return scaleDimensions(104)
  }
}

/** @deprecated Use pictureChoiceDimensions — height only helper for legacy callers. */
export function pictureChoiceImageHeightPx(size: SurveyImageSize): number {
  return pictureChoiceDimensions(size).height
}
